module.exports = __webpack_public_path__ + "static/media/background.80ca3391.jpeg";